import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { SharedUtilConfigurationModule } from "@kno2/core/configuration";
import { SharedUtilIntegrationsModule } from "@kno2/core/integrations";
import { DesktopDataAccessApiDesktopModule } from "@kno2/data-access/api-desktop";
import { SharedApiKno2fyMainModule } from "@kno2/data-access/api-kno2fy-main";
import { AuthInterceptor } from "./interceptors/auth.interceptor";
import { StoreModuleConfiguration } from "./store.module";

@NgModule({
    imports: [
        SharedUtilConfigurationModule,
        SharedApiKno2fyMainModule,
        StoreModuleConfiguration,
        SharedUtilIntegrationsModule,
        DesktopDataAccessApiDesktopModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        }
    ]
})
export class CoreModule {}
